import { Card } from "shared/components/Card";
import { Application } from "types/application";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { Fragment } from "react";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { cx } from "shared/utils";
import { RuleSetDecision } from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";
import { Accordion } from "shared/app/ExplainRecommendationModal/components/Accordion";

export const ApprovalConditions = ({
  application
}: {
  application: Application;
}) => {
  const approvalRules = application.rule_reasons?.filter(
    (rs) => rs.rule_set_type === RuleSetDecision.Approve
  );

  if (!approvalRules) return null;

  return (
    <Card>
      <div className="flex gap-2 py-4 px-6 border-b border-alpha-40">
        <SuccessIcon className="w-5 shrink-0 text-success-500" />
        <h2 className="text-base font-bold text-content-1000">
          Recommend approval when
        </h2>
      </div>

      <div className="p-6">
        {approvalRules.map((ruleSet, idx) => {
          const activeRules = ruleSet.rules.filter((rule) => !rule.skipped);
          const isMetConditions =
            activeRules.length > 0 &&
            activeRules.every((el) => el.result === true);

          return (
            <Fragment key={ruleSet.rule_set_id}>
              <Show if={idx !== 0}>
                <div className="flex gap-6 items-center my-4">
                  <Badge variant={BadgeVariant.BASE} size={BadgeSize.BASE}>
                    OR
                  </Badge>
                  <div className="w-full h-px bg-alpha-40"></div>
                </div>
              </Show>
              <Card
                className={cx(
                  " relative border border-alpha-100 py-8 px-6",
                  isMetConditions ? "!bg-primary-20" : "!bg-background-900"
                )}
              >
                <Badge
                  variant={BadgeVariant.OUTLINE}
                  size={BadgeSize.BASE}
                  className={cx(
                    "absolute -top-3 left-1/2 -translate-x-1/2",
                    isMetConditions && "!bg-primary-500"
                  )}
                >
                  <p
                    className={cx(
                      " text-xs font-bold",
                      isMetConditions
                        ? "text-content-1000-inverted font-bold"
                        : "text-content-700 font-medium"
                    )}
                  >
                    {isMetConditions
                      ? "Approval conditions were met"
                      : "Approval conditions weren’t met"}
                  </p>
                </Badge>

                {ruleSet.rules.map((rule, idx) => {
                  return (
                    <Accordion
                      idx={idx}
                      rule={rule}
                      ruleSet={ruleSet}
                      key={ruleSet.rule_set_id}
                      application={application}
                    />
                  );
                })}
              </Card>
            </Fragment>
          );
        })}
      </div>
    </Card>
  );
};
